<template>
  <div>
    <form class="forgot-password-form" novalidate @submit.prevent="submitResetPassword">
      <div class="forgot-password-form__section">
        <FormInput
          ref="email"
          name="email"
          type="email"
          v-model="email"
          v-validate="'required|email'"
          :readonly="authenticated"
          :hint="$t('forgot-password.id-subtitle')"
          :error="emailError"
          :label="$t('forgot-password.id')"
          has-gray-background
          v-on:blur="handleBlur"
        />
      </div>

      <FormButton
        hasIconRight
        type="submit"
        class="forgot-password-form__forgot-password-btn"
        :disabled="isFormInvalid"
        :is-outlined="isFormInvalid"
      >
        {{ $t('forgot-password.button') }}
        <BaseIcon name="arrow-right" />
      </FormButton>
    </form>
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex';

import BaseIcon from '@/components/base/BaseIcon';
import FormButton from '@/components/form/FormButton.vue';
import FormInput from '@/components/form/FormInput.vue';

export default {
  components: {
    BaseIcon,
    FormButton,
    FormInput,
  },
  data() {
    return {
      email: '',
    };
  },

  inject: ['$validator'],
  computed: {
    ...mapGetters('auth', ['authenticated', 'currentUser']),
    isFormInvalid() {
      return !this.email || this.errors.items.length > 0;
    },
    emailError() {
      const error = this.errors.items.find((x) => x.field === 'email');

      return error ? error.msg : undefined;
    },
  },
  methods: {
    ...mapActions('auth', ['resetPassword']),
    submitResetPassword() {
      this.resetPassword(this.email);
      this.$emit('submit', this.email);
    },
    handleBlur() {
      window.scrollTo(0, 0);
    },
  },
  mounted() {
    this.email = this.authenticated ? this.currentUser.email : '';
    const refInput = this.$refs.email.$el.querySelector('input');
    if (refInput) {
      refInput.focus();
    }
  },
};
</script>

<style lang="scss">
.forgot-password-form {
  &__section {
    margin-bottom: 20px;
    width: 25rem;
    justify-content: center;
    display: flex;
    margin: auto;
  }

  &__row {
    display: flex;
    margin-bottom: 40px;
  }

  &__forgot-password-btn {
    margin: 2.5rem auto 0 auto;
  }

  @media screen and (max-width: 784px) {
    width: 100%;

    &__section {
      width: 100%;

      .form-input {
        width: 100%;
      }
    }
  }

  @media screen and (max-width: 468px) {
    .form-input__hint {
      height: 12px;
      text-align: left;
    }
  }
}
</style>
